module.exports = __webpack_public_path__ + "static/media/img_Characterdesign-Junior-02Second_J12.d554dbcd.png";